import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface EmailComposeData {
  type: "client" | "driver";
  to: string;
  cc?: string;
  subject: string;
  body: string;
}

@Component({
  selector: "app-email-compose-modal",
  templateUrl: "./email-compose-modal.component.html",
  styleUrls: ["./email-compose-modal.component.css"],
})
export class EmailComposeModalComponent {
  @Input() visible = false;
  @Input() email: EmailComposeData | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<EmailComposeData>();
  @Output() cancelled = new EventEmitter<void>();

  get header(): string {
    return this.email?.type === "client" ? "Email Client" : "Email Driver";
  }

  onConfirm(): void {
    if (!this.email) return;
    this.confirmed.emit({ ...this.email });
    this.close();
  }

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.cancelled.emit();
  }

  onHide(): void {
    this.cancelled.emit();
  }
}
